import Vue from 'vue';
export default {
  data() {
    return {
      missionsInformationTableHeaders: [
        {
          text: 'ناحیه',
          value: 'zoneTitle',
          align: 'center',
          width: '180px',
          isGroupable: true,
        },
        {
          text: 'انتقال به مرکز درمانی',
          value: 'transferCount',
          align: 'center',
          width: '210px',
          isGroupable: true,
        },
        {
          text: 'درمان سرپایی',
          value: 'initialTreatmentCount',
          align: 'center',
          width: '190px',
          isGroupable: true,
        },
        {
          text: 'عدم همکاری و اخذ امضا',
          value: 'noCollaborationAndSignCount',
          align: 'center',
          width: '290px',
          isGroupable: true,
        },
        {
          text: 'مرگ قطعی',
          value: 'deathCount',
          align: 'center',
          width: '180px',
          isGroupable: true,
        },
        {
          text: 'تحویل به کد دیگر',
          value: 'transferToAnotherCodeCount',
          align: 'center',
          width: '270px',
          isGroupable: true,
        },
        {
          text: 'عدم همکاری از هر نوع اقدام درمانی',
          value: 'ignoreByPatient',
          align: 'center',
          width: '320px',
          isGroupable: true,
        },
        {
          text: 'لغو از طرف مرکز',
          value: 'cancelCount',
          align: 'center',
          width: '320px',
          isGroupable: true,
        },
        {
          text: 'ماموریت کاذب',
          value: 'fakeMissionCount',
          align: 'center',
          width: '190px',
          isGroupable: true,
        },
        {
          text: 'عدم حضور بیمار',
          value: 'noPatientCount',
          align: 'center',
          width: '210px',
          isGroupable: true,
        },
        {
          text: 'استقرار',
          value: 'deploymentCount',
          align: 'center',
          width: '90px',
          isGroupable: true,
        },
        {
          text: 'انتقال حین احیاء',
          value: 'transferAndResuscitationCount',
          align: 'center',
          width: '210px',
          isGroupable: true,
        },
        {
          text: 'فوت در حضور تکنسین',
          value: 'deathInPresenceOfTechnicianCount',
          align: 'center',
          width: '250px',
          isGroupable: true,
        },
        {
          text: 'تعداد مددجو',
          value: 'patientCount',
          align: 'center',
          width: '190px',
          isGroupable: true,
        },
        {
          text: 'تعداد ماموریت',
          value: 'missionCount',
          align: 'center',
          width: '210px',
          isGroupable: true,
        },
      ],
      missionsDailyReportItmes: [],
      resultsInformationTableHeaders: [
        { text: 'ردیف', value: 'number', align: 'center', isGroupable: false },
        { text: 'عنوان', value: 'title', align: 'center', isGroupable: true },
        { text: 'تعداد', value: 'count', align: 'center', isGroupable: true },
      ],
      resultsDailyReportItmes: [],
      callsInformationTableHeaders: [
        { text: 'ردیف', value: 'number', align: 'center', isGroupable: false },
        { text: 'عنوان', value: 'title', align: 'center', isGroupable: true },
        { text: 'تعداد', value: 'count', align: 'center', isGroupable: true },
      ],
      callsDailyReportItmes: [],
      searchFromDate: '',
      searchToDate: '',
      tempSearchFromDate: '',
      showSearchFromDate: false,
      tempSearchToDate: '',
      showSearchToDate: false,
      searchCityId: null,
    };
  },
  methods: {
    setPreTimes: function () {
      this.tempSearchFromDate = '00:00:00 ';
      let temp = Vue.moment().format('jYYYY-jMM-jDD');
      this.tempSearchFromDate += temp;
      this.searchFromDate = Vue.moment().format('YYYY-MM-DD');
      this.searchFromDate += 'T00:00:00';
      this.searchToDate = Vue.moment().format('YYYY-MM-DDTHH:mm:ss');
      this.tempSearchToDate = Vue.moment().format('HH:mm:ss jYYYY-jMM-jDD');
    },
    dateTimeChange: function (type) {
      if (type == 'searchFromDate') {
        if (this.searchFromDate) {
          this.tempSearchFromDate = Vue.moment(this.searchFromDate).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      } else if (type == 'searchToDate') {
        if (this.searchToDate) {
          this.tempSearchToDate = Vue.moment(this.searchToDate).format('HH:mm:ss jYYYY-jMM-jDD');
        }
      }
    },
    clearDateTime: function (type) {
      if (type == 'searchFromDate') {
        this.showSearchFromDate = false;
        this.searchFromDate = '';
        this.tempMoveFromStationTime = '';
      } else if (type == 'searchToDate') {
        this.showSearchToDate = false;
        this.searchToDate = '';
        this.tempSearchFromDate = '';
      }
    },
    makeMissionByZoneDataReady: function (data) {
      this.missionsDailyReportItmes = [];
      for (const mission of data) {
        this.missionsDailyReportItmes.push({
          zoneTitle: mission.zoneTitle ? mission.zoneTitle : '-',
          transferCount: mission.transferCount,
          initialTreatmentCount: mission.initialTreatmentCount,
          noCollaborationAndSignCount: mission.noCollaborationAndSignCount,
          deathCount: mission.deathCount,
          transferToAnotherCodeCount: mission.transferToAnotherCodeCount,
          noCollaborationCount: mission.noCollaborationCount,
          cancelCount: mission.cancelCount,
          fakeMissionCount: mission.fakeMissionCount,
          noPatientCount: mission.noPatientCount,
          deploymentCount: mission.deploymentCount,
          patientCount: mission.patientCount,
          missionCount: mission.missionCount,
          ignoreByPatient: mission?.ignoreByPatient,
          transferAndResuscitationCount: mission?.transferAndResuscitationCount,
          deathInPresenceOfTechnicianCount: mission?.deathInPresenceOfTechnicianCount,
        });
      }
    },
    makeDiagnosisDataReady: function (data) {
      this.resultsDailyReportItmes = [];
      for (const [index, result] of data.entries()) {
        this.resultsDailyReportItmes.push({
          number: index + 1,
          title: result.title ? result.title : '-',
          count: result.valueLong,
        });
      }
    },
    makeCallsDataReady: function (data) {
      this.callsDailyReportItmes = [];
      for (const [index, result] of data.entries()) {
        this.callsDailyReportItmes.push({
          number: index + 1,
          title: result.title ? result.title : '-',
          count: result.valueLong,
        });
      }
    },
    search: function () {
      this.getMissionPhoneWithResultByZoneForDailyReportAmarFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchCityId,
      );
      this.getPatientCountByDiagnosisForDailyReportAmarFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchCityId,
      );
      this.getInboundCallsForDailyReportAmarFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchCityId,
      );
    },
    goToDailyReportByZone: function () {
      let id = `${this.searchFromDate}_${this.searchToDate}_${this.searchCityId}`;
      const routeData = this.$router.resolve({
        name: 'dailyByZoneExport',
        params: { id: id },
      });
      window.open(routeData.href, '_blank');
    },
    goToDailyReportByGeographicalType: function () {
      let id = `${this.searchFromDate}_${this.searchToDate}_${this.searchCityId}`;
      const routeData = this.$router.resolve({
        name: 'dailyByGeographicalTypeExport',
        params: { id: id },
      });
      window.open(routeData.href, '_blank');
    },
    goToDailyReportByGeographicalTypeWithCode: function () {
      let id = `${this.searchFromDate}_${this.searchToDate}_${this.searchCityId}`;
      const routeData = this.$router.resolve({
        name: 'dailyByCodeExport',
        params: { id: id },
      });
      window.open(routeData.href, '_blank');
    },
  },
};
